export default __webpack_public_path__ + "static/media/product-07 (2).fea32407.jpg";